import { OfflineError } from "./api.ts";

/**
 * How many times a read is tried again before the screen says it failed.
 *
 * Opened from the home screen, the app often asks before Tailscale is back up
 * on the phone: the first requests fail in a few milliseconds, and one quick
 * retry was spent before the tunnel had come back — the home screen stayed
 * empty (14/10). An unreachable server is worth waiting for; a refusal from
 * it is not.
 */
export function shouldRetry(failureCount: number, error: unknown): boolean {
  return failureCount < (error instanceof OfflineError ? 4 : 1);
}

/** 1, 2, 4, then 8 s: about fifteen seconds for the tunnel to come back. */
export function retryDelay(attempt: number): number {
  return Math.min(1000 * 2 ** attempt, 8000);
}
